export const categories = [
  {
    category: "Full Helmets",
  },
  {
    category: "Half Helmets",
  },
  {
    category: "Dirt Helmets",
  },
  {
    category: "Cycle Helmets",
  },
];

export const brands = [
  {
    brand: "AGV",
  },
  {
    brand: "Airoh",
  },
  {
    brand: "Axor",
  },
  {
    brand: "Bell",
  },
];

export const filterOptions = [
  { key: "full_helmet", name: "Full Helmets" },
  { key: "half_helmet", name: "Half Helmets" },
  { key: "dirt_helmet", name: "Dirt Helmets" },
  { key: "kid_helmet", name: "Kid Helmets" },
  { key: "cycle_helmet", name: "Cycle Helmets" },
];

export const sortBy = [
  { id: 1, sort: "Newest Arrivals" },
  { id: 2, sort: "Price: Low to High" },
  { id: 3, sort: "Price: High to Low" },
];

export const displayNumber = [{ perPage: 9 }, { perPage: 18 }, { perPage: 27 }];

export const itemsList = [
  {
    id: 1,
    tag: {
      type: "new",
      name: "New",
    },
    rating: 3.5,
    reviews: 4,
    name: "Bilmola Defender Treasure (Turquoise)",
    oldPrice: 5000.0,
    newPrice: 4500.0,
    colors: ["#000000", "#324D85", "#A8B3B5"],
    sizes: ["XXL", "XL", "MD", "SM"],
    images: [
      { id: 1, image: "/img/helmets/helmet01.png", color: "#000000" },
      { id: 2, image: "/img/helmets/helmet02.png", color: "#324D85" },
      { id: 3, image: "/img/helmets/helmet03.png", color: "#A8B3B5" },
    ],
  },
  {
    id: 2,
    tag: {
      type: "sale",
      name: "Sale 20% off",
    },
    rating: 3.5,
    reviews: 4,
    name: "Defender Treasure (Turquoise)",
    oldPrice: 5000.0,
    newPrice: 4500.0,
    colors: ["#000000", "#324D85", "#A8B3B5"],
    sizes: ["XXL", "XL", "MD", "SM"],
    images: [
      { id: 1, image: "/img/helmets/helmet02.png", color: "#000000" },
      { id: 2, image: "/img/helmets/helmet03.png", color: "#324D85" },
      { id: 3, image: "/img/helmets/helmet01.png", color: "#A8B3B5" },
    ],
  },
  {
    id: 3,
    tag: {
      type: "sale",
      name: "Sale 5% off",
    },
    rating: 4.5,
    reviews: 10,
    name: "Sedici Sistema II Helmet - Solid",
    oldPrice: 5000.0,
    newPrice: 4500.0,
    colors: ["#000000", "#324D85", "#A8B3B5"],
    sizes: ["XXL", "XL", "MD", "SM"],
    images: [
      { id: 1, image: "/img/helmets/helmet04.png", color: "#000000" },
      { id: 2, image: "/img/helmets/helmet02.png", color: "#324D85" },
      { id: 3, image: "/img/helmets/helmet03.png", color: "#A8B3B5" },
    ],
  },
  {
    id: 4,
    tag: {
      type: "sale",
      name: "20% off",
    },
    rating: 4.5,
    reviews: 10,
    name: "BILT Techno 3.0 Modular Sena Bluetooth Helmet",
    oldPrice: 5000.0,
    newPrice: 4500.0,
    colors: ["#000000", "#324D85", "#A8B3B5"],
    sizes: ["XXL", "XL", "MD", "SM"],
    images: [
      { id: 1, image: "/img/helmets/helmet01.png", color: "#000000" },
      { id: 2, image: "/img/helmets/helmet04.png", color: "#324D85" },
      { id: 3, image: "/img/helmets/helmet03.png", color: "#A8B3B5" },
    ],
  },
  {
    id: 5,
    tag: {
      type: "new",
      name: "New",
    },
    rating: 3.5,
    reviews: 4,
    name: "Bilmola Defender Treasure (Turquoise)",
    oldPrice: 5000.0,
    newPrice: 4500.0,
    colors: ["#000000", "#324D85", "#A8B3B5"],
    sizes: ["XXL", "XL", "MD", "SM"],
    images: [
      { id: 1, image: "/img/helmets/helmet01.png", color: "#000000" },
      { id: 2, image: "/img/helmets/helmet02.png", color: "#324D85" },
      { id: 3, image: "/img/helmets/helmet03.png", color: "#A8B3B5" },
    ],
  },
  {
    id: 6,
    tag: {
      type: "sale",
      name: "Sale 20% off",
    },
    rating: 3.5,
    reviews: 4,
    name: "Defender Treasure (Turquoise)",
    oldPrice: 5000.0,
    newPrice: 4500.0,
    colors: ["#000000", "#324D85", "#A8B3B5"],
    sizes: ["XXL", "XL", "MD", "SM"],
    images: [
      { id: 1, image: "/img/helmets/helmet02.png", color: "#000000" },
      { id: 2, image: "/img/helmets/helmet03.png", color: "#324D85" },
      { id: 3, image: "/img/helmets/helmet01.png", color: "#A8B3B5" },
    ],
  },
  {
    id: 7,
    tag: {
      type: "sale",
      name: "Sale 5% off",
    },
    rating: 4.5,
    reviews: 10,
    name: "Sedici Sistema II Helmet - Solid",
    oldPrice: 5000.0,
    newPrice: 4500.0,
    colors: ["#000000", "#324D85", "#A8B3B5"],
    sizes: ["XXL", "XL", "MD", "SM"],
    images: [
      { id: 1, image: "/img/helmets/helmet04.png", color: "#000000" },
      { id: 2, image: "/img/helmets/helmet02.png", color: "#324D85" },
      { id: 3, image: "/img/helmets/helmet03.png", color: "#A8B3B5" },
    ],
  },
  {
    id: 8,
    tag: {
      type: "sale",
      name: "20% off",
    },
    rating: 4.5,
    reviews: 10,
    name: "BILT Techno 3.0 Modular Sena Bluetooth Helmet",
    oldPrice: 5000.0,
    newPrice: 4500.0,
    colors: ["#000000", "#324D85", "#A8B3B5"],
    sizes: ["XXL", "XL", "MD", "SM"],
    images: [
      { id: 1, image: "/img/helmets/helmet01.png", color: "#000000" },
      { id: 2, image: "/img/helmets/helmet04.png", color: "#324D85" },
      { id: 3, image: "/img/helmets/helmet03.png", color: "#A8B3B5" },
    ],
  },
];
